import React, { createContext, useContext, useEffect, useState } from "react";
import { useSocket } from "../hooks/useSocket";
import { AuthContext } from "../context/authContext/authContext";

export const SocketContext = createContext();
export const SocketProvider = ({ children }) => {
  const { socket, connectSocket, disconnectSocket } = useSocket(
    // process.env.REACT_APP_SOCKET
    process.env.REACT_APP_MODE === "LOCAL"
      ? process.env.REACT_APP_SOCKET_LOCAL
      : process.env.REACT_APP_MODE === "PRODUCTION"
      ? window.location.protocol +
        "//" +
        window.location.hostname +
        process.env.REACT_APP_SOCKET_PROD
      : process.env.REACT_APP_SOCKET_TEST
  );
  const [connected, setConnected] = useState(false);
  const { user } = useContext(AuthContext);
  // Si está conectado
  useEffect(() => {
    if (user.token) {
      connectSocket();
    }
  }, [user, connectSocket]);
  // Si está desconectado
  useEffect(() => {
    if (!user.token) {
      setConnected(false);
      disconnectSocket();
    }
  }, [user, disconnectSocket]);
  return (
    <SocketContext.Provider value={{ socket, connected }}>
      {children}
    </SocketContext.Provider>
  );
};
